import { gql } from "urql";
export const ChatMessageReceivedSubscription = gql `
    subscription ChatMessageReceived {
        chatMessageReceived {
            chatMessageId
            chatRoomId
            senderUserId
            threadParentId
            content
            contentText
            isEdited
            isDeleted
            threadReplyCount
            threadLastReplyAt
            senderFirstName
            senderLastName
            senderImageUrl
            isPinned
            createdAt
            updatedAt
            reactions {
                chatReactionId
                chatMessageId
                userId
                emoji
                createdAt
                firstName
                lastName
            }
        }
    }
`;
export const ChatMessageUpdatedSubscription = gql `
    subscription ChatMessageUpdated {
        chatMessageUpdated {
            chatMessageId
            chatRoomId
            updateType
            message {
                chatMessageId
                chatRoomId
                senderUserId
                threadParentId
                content
                contentText
                isEdited
                isDeleted
                threadReplyCount
                threadLastReplyAt
                senderFirstName
                senderLastName
                senderImageUrl
                isPinned
                createdAt
                updatedAt
                reactions {
                    chatReactionId
                    chatMessageId
                    userId
                    emoji
                    createdAt
                    firstName
                    lastName
                }
            }
        }
    }
`;
export const ChatRoomUpdatedSubscription = gql `
    subscription ChatRoomUpdated {
        chatRoomUpdated {
            chatRoomId
            updateType
            room {
                chatRoomId
                type
                name
                description
                isGroupDm
                isArchived
                lastMessageAt
                createdByUserId
                createdAt
                updatedAt
                members {
                    chatRoomMemberId
                    userId
                    firstName
                    lastName
                    email
                    imageUrl
                    lastReadAt
                    isMuted
                    joinedAt
                }
            }
        }
    }
`;
